import React from 'react'
import { Link } from "react-scroll";

const NavLinks = () => {

    return (
        <ul >
            <li  >
                <Link to="home" smooth="true" duration={550} >
                    <a href='/#home'>Home</a>
                </Link>
            </li>
            <li>
                <Link to="about-me" smooth="true" offset={-85} duration={550}>
                    <a href='/#about'>Biography</a>
                </Link>

            </li>
            <li>
                <Link to="experience" smooth="true" offset={-50} duration={550}>
                    <a href='/#experience'>Work Experience</a>
                </Link>
            </li>
            <li>
                <Link to="projects" smooth="true" offset={-60} duration={550}>
                    <a href='/#projects'>Projects</a>
                </Link>
            </li>


        </ul>
    )
}

export default NavLinks